
import locale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  lang: 'zh-CN',
  // header
  chooseLanguage: '选择语言',
  nav: {
    home: '首页',
    about: {
      title: '走进东浩',
      submenu: {
        Companyprofile: "企业简介",
        Organization: "组织架构",
        Corporateculture: "企业文化",
        Honor: "资质荣誉",
        History: "发展历程"
      }
    },
    research: {
      title: '科研中心',
      submenu: {
        Production: "生产实力",
        research: "科研中心",
        Quality: "品质管理",
        Equipment: "设备仪器"
      }
    },
    products: '产品与方案',
    news: '新闻资讯',
    job: '人力资源',
    job2: '人才招聘',
    contact: '联系我们',
    contact2: '联系方式'
  },
  home: {
    about: {
      title: '东浩铸业',
      content: '<p>宁波东浩铸业有限公司成立于1992年，是一家集模具设计与制造、铝/锌合金的压铸、压铸件精密机械加工和表面处理为一体的制造型的中外合资企业。</p><p>公司位于宁波市鄞州区东吴镇，与“天下禅宗五山”之一的太白山天童寺相邻相伍，注册资金400万美元，占地面积40000多平方米，建筑面积28000平方米...</p>',
      data: ['公司占地','服务客户','国家专利']
    },
    service: '公司以科学的管理模式，先进的制造设备，精密的检测手段和高素质的专业人才队伍为保证，生产的产品性能稳定可靠，质量达到国际同类产品的先进水平，畅销欧美、日本、东南亚等地。并且可根据国内外用户需... ...',
    products: '公司通过IATF16949: 2016质量体系，目前集研发、生产、销售于一体的高新技术企业。公司主要为汽车零部件、八音琴零部件、纺织机械等行业提供各种精密压铸件和模具。目前是Prestlite（佩特来）、VALEO（法雷奥）、BORGWARNER（博格华纳）、MAHLE（马勒）ITT、SKF等国际知名公司的指定供应商，具有良好的国际信誉。'
  },
  about: {
    CompanyProfile:[
      '宁波东浩铸业有限公司创办于1992年，是一家集模具设计与制造、铝、锌合金压铸、压铸件精密加工及表面处理为一体的专业制造型企业。',
      '公司位于宁波市鄞州区东吴镇，占地40000多平方米，建筑面积28000平方米。拥有各型国际著名品牌的压铸机20余台、高速/高精度加工中心、数控车床120余台、自动上料加工线3条、高精度电加工机床、表面处理设备、其他精密专用设备100余台。拥有高精度大型三坐标测量设备2台和X光探伤设备、光谱仪及其他精密计量检测设备，以及各类先进设计与模拟分析软件，为满足海内外客户的产品品质的需求提供坚实保障。',
      '公司主要为汽车零部件、八音琴零部件、纺织机械等行业提供各类精密压铸模具、压铸及精密机械加工零部件。是国际著名公司Prestlite（佩特来）、VALEO(法雷奥)、BORGWARNER（博格华纳）、MAHLE（马勒）、ITT、SKF指定配套供应商。',
      '公司通过IATF16949: 2016质量体系，现为浙江省高新技术企业，市“模具50强企业”之一。本公司自创办以来，始终坚持“以人为本、用户至上、博采众长、不断进取”的经营理念，“科学管理、精益制造、持续改善、顾客满意”的质量方针，以诚信务实的作风、开拓向上的进取精神及良好的售后服务，使公司持续、健康、稳定发展，走在同行业的前列。'
    ],
    Corporateculture: {
      title: '核心价值观“专注铸造专业品质”',
      content: '<p>核心价值观是指企业及全体员工共同的价值取向，是指企业在追求经营成功过程中所推崇的基本信念和奉行的目标。</p><p>尽，指发自内心、不惜一切的投入；心，指热情与热爱；力，指智慧与汗水；成就，代表回报；您我，代表共赢；您，表示关注和尊重（把你放在心上）。也就是说,东浩人发自内心的热爱自己的事业，在工作中不惜一切的奉献自己的智慧与汗水，终将会得到丰厚的回报，并让客户、员工、供应商，以及社会共同获利受惠。</p>'
    }
  },
  // element-ui
  ...locale
}
